<template>
    <v-container fluid class="full">
      <div ref="map-root" style="width: 500px; height: 500px"></div>
    </v-container>
  </template>
  
  <script>
  import { Map, View, Feature } from "ol";
  import { useGeographic } from "ol/proj";
  import Point from "ol/geom/Point.js";
  import LayerGroup from "ol/layer/Group";
  import TileLayer from "ol/layer/Tile";
  import GeoJSON from "ol/format/GeoJSON";
  import { Vector as VectorSource } from "ol/source.js";
  import VectorLayer from "ol/layer/Vector";
  // import VectorTileLayer from "ol/layer/VectorTile";
  // import VectorTileSource from "ol/source/VectorTile";
  import OSM from "ol/source/OSM";
  import XYZ from "ol/source/XYZ";
  // import MVT from "ol/format/MVT";
  // import { Circle, RegularShape, Stroke, Fill, Style, Text } from "ol/style";
  import { Circle, Stroke, Fill, Style, Text } from "ol/style";
  import { getWidth } from "ol/extent";
  import { defaults as defaultControls } from "ol/control";
  import LayerSwitcher from "ol-layerswitcher";
  import "ol/ol.css";
  import "ol-layerswitcher/dist/ol-layerswitcher.css";
  
    import { polygon, bboxPolygon,intersect } from "@turf/turf"
  
  import localforage from "localforage";
  
  import axios from "axios";
  axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT_URL;
    axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
    axios.defaults.withCredentials = true;
  
  export default {
    name: "OpenLayersMap",
    components: {},
    props: {
      center: Array,
      zoom: Number,
      pointStyle: Object,
      symbologyField: {
        type: String,
        default: "placed"
      },
      points: Object,
      latitude: Number,
      longitude: Number,
      idField: String,
      selectedId: Number,
      vectorTitle: {
        type: String,
        default: "Point Layer"
      }
    },
    data: () => ({
      map: null,
      baseLayers: null,
      feature: null,
      vectorLayers: null,
      vectorSource: null,
      vectorLayer: null,
      featureLayer: null,
      LayerSwitcher: null,
      currentZoom: null,
      currentCenter: null,
    }),
    computed: {
      extent: function () {
        return this.map.getView().calculateExtent(this.map.getSize());
      },
    },
    watch: {
      center(n) {
        if (this.currentZoom === 10) {
          this.currentZoom = 17;
        }
        console.log(n);
        this.map.setView(
          new View({
            center: n,
            zoom: this.currentZoom,
          }),
        );
        this.currentCenter = n;
      },
      points() {
        let features = new GeoJSON().readFeatures(this.points)
        this.vectorSource.clear()
        this.vectorSource.addFeatures(features);

        this.map.render();
      }
    },
    created() {},
    mounted: async function () {
      useGeographic();
      if (typeof this.points !== "undefined") {
        this.vectorSource = new VectorSource({
          features: new GeoJSON().readFeatures(this.points),
        });
      } else {
        this.feature = new Feature({
          geometry: new Point([this.longitude, this.latitude]),
        });
        this.vectorSource = new VectorSource();
        this.vectorSource.addFeature(this.feature);
      }
      this.vectorLayer = new VectorLayer({
        name: this.vectorTitle,
        source: this.vectorSource,
        style: this.pointStyleFunction,
      });
      this.featureLayer = new VectorLayer({ name: "selected" });
      this.baseLayers = new LayerGroup({
        title: "Base layers",
        layers: [
          new TileLayer({
            title: "Open Street Map",
            type: "base",
            source: new OSM(),
            visible: true,
          }),
          // new TileLayer({
          //   title: "USGS Topo",
          //   type: "base",
          //   source: new XYZ({
          //     url: "https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}",
          //     attributions: [
          //       "USGS The National Map: National Boundaries Dataset, 3DEP Elevation Program, Geographic Names Information System, National Hydrography Dataset, National Land Cover Database, National Structures Dataset, and National Transportation Dataset; USGS Global Ecosystems; U.S. Census Bureau TIGER/Line data; USFS Road Data; Natural Earth Data; U.S. Department of State Humanitarian Information Unit; and NOAA National Centers for Environmental Information, U.S. Coastal Relief Model. Data refreshed April, 2023.",
          //     ],
          //   }),
          //   opacity: 1.0,
          // }),
          // new TileLayer({
          //   title: "ESRI World Imagery",
          //   type: "base",
          //   source: new XYZ({
          //     url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
          //     attributions: ["Tiles © ArcGIS"],
          //   }),
          //   opacity: 1.0,
          // }),
        ],
      });
     let osmLayer = new TileLayer({
            title: "Open Street Map",
            type: "base",
            source: new OSM(),
            visible: true,
          })
        this.baseLayers = new LayerGroup({
        title: "Base layers",
        layers: [osmLayer]
        })

      this.vectorLayers = new LayerGroup({
        title: this.vectorTitle,
        layers: [this.vectorLayer, this.featureLayer],
      });
      this.map = new Map({
        target: this.$refs["map-root"],
        layers: [osmLayer, this.vectorLayers],
        controls: defaultControls({
          attributionOptions: {
            collapsible: true,
          },
        }),
      });
      this.map.setView(
        new View({
          center: [this.longitude, this.latitude],
          zoom: this.zoom,
        }),
      );
      this.layerSwitcher = new LayerSwitcher();
      this.map.addControl(this.layerSwitcher);
  
      this.map.on("moveend", this.checkZoom);
  
      this.currentZoom = this.map.getView().getZoom();
      this.currentCenter = this.map.getView().getCenter();
      
      //handle feature click
      this.map.on('click', (event) => {
        // Get the feature at the clicked pixel
        this.map.forEachFeatureAtPixel(event.pixel, (feature) => {
          if (feature) {
            // Handle feature click here
            console.log('Clicked Feature:', feature.getProperties()[this.idField]);
            this.$emit("featureSelected",feature.getProperties()[this.idField]);
            // You can access feature properties using feature.getProperties()
          }
        });
      });
      
    },
    methods: {
      getIDText: function (feature, resolution) {
        let text = feature.get(this.idField);
        if (resolution > 17) {
          text = "";
        }
  
        return text;
      },

      createTextStyle: function (feature, resolution) {
        return new Text({
          font: "12px sans-serif",
          text: this.getIDText(feature, resolution),
          fill: new Fill({ color: "black" }),
          stroke: new Stroke({ color: "white", width: 3 }),
          offsetX: 10,
          offsetY: -10,
        });
      },
      pointStyleFunction: function (feature, resolution) {
        //let colorOptions = [{ color: 'red' }, { color: 'blue' }, { color: 'yellow' }, { color: 'darkred' }]
        const colorOptions = ["yellow", "red","blue","darkred"];
        const featureId = feature.get(this.idField);
        const coords = feature.getGeometry().getCoordinates();
        console.log(colorOptions[feature.get(this.symbologyField)].toString())
        console.log(typeof colorOptions[feature.get(this.symbologyField)].toString())
        //let fill = new Fill({ color: colorOptions[1].toString()})
        let fillcolor = colorOptions[feature.get(this.symbologyField)];
        let strokeColor = this.pointStyle.strokeColor;
        //let strokeColor = "red"
        let radius = this.pointStyle.radius;
        if (
          featureId === this.selectedId ||
          (Math.abs(coords[0] - this.longitude) < 0.00001 &&
            Math.abs(coords[1] - this.latitude) < 0.00001)
        ) {
          fillcolor = "orange";
          strokeColor = "darkviolet";
          radius = 6;
        }

        return new Style({
          image: new Circle({
            fill: new Fill({ color: fillcolor }),
            stroke: new Stroke({
              color: strokeColor,
              width: this.pointStyle.strokeWidth,
            }),
            radius: radius,
          }),
          text: this.createTextStyle(feature, resolution),
        });
      },
      createSiteTextStyle: function (feature, resolution) {
        return new Text({
          font: "12px sans-serif",
          text: this.getSiteText(feature, resolution),
          fill: new Fill({ color: "black" }),
          stroke: new Stroke({ color: "white", width: 3 }),
          offsetX: 10,
          offsetY: -10,
        });
      },

      polygonStyleFunction: function (feature, resolution) {
        return new Style({
          stroke: new Stroke({
            color: "blue",
            width: 1,
          }),
          fill: new Fill({
            color: "rgba(0, 0, 255, 0.1)",
          }),
          text: this.createSiteTextStyle(feature, resolution),
          geometry: this.setSiteTextGeometry(feature),
        });
      },
      checkZoom: function () {
        let newZoom = this.map.getView().getZoom();
        let newCenter = this.map.getView().getCenter();
        if (newZoom !== this.currZoom) {
          this.currentZoom = newZoom;
          localforage.setItem("zoom", newZoom);
        }
        if (newCenter !== this.currCenter) {
          this.currentCenter = newCenter;
          localforage.setItem("center_x", newCenter[0]);
          localforage.setItem("center_y", newCenter[1]);
        }
      },
    },
  };
  </script>
  
  <style>
  .full {
    display: flex;
    flex-flow: column;
    height: 100%;
  }
  
  .fill {
    flex: 1 1 auto;
  }
  
  .bottom {
    flex: 0 1 0 !important;
  }
  
  .layer-switcher {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    text-align: left;
  }
  
  .layer-switcher .panel {
    font-size: 0.8em;
    background-color: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(64, 64, 64, 0.7);
  }
  
  .layer-switcher ul {
    list-style: none;
    margin: 1em 0.4em;
    padding-left: 0;
  }
  
  .layer-switcher ul ul {
    padding-left: 0.6em;
    margin: 0.1em 0 0 0;
  }
  </style>
  